import React, { useCallback } from "react"
import { Field } from "formik"
import { Translate } from "utils/i18n-shim"
import { Grid, Stack, Button } from "@mui/material"

import { MainCard } from "shared/ui/berry-jass"
import { RemoteAutocomplete } from "shared/ui/berry-jass-formik"
import useLocale from "hooks/useLocale"
import { getEmptyLocationValues } from "../lib"
import { Location } from "./Location"

const LocationsSectionComponent = ({ form, push, remove, name }) => {
  const fields = form.values[name]
  const disableRemove = fields.length < 2
  const locale = useLocale()

  const handleAdd = useCallback(() => {
    push(getEmptyLocationValues())
  }, [push])

  const handleRemove = useCallback(
    (i) => {
      if (!disableRemove) {
        remove(i)
      }
    },
    [disableRemove, remove]
  )
  return (
    <MainCard
      title={<Translate value="location" />}
      contentSX={{ p: 2 }}
      secondary={
        <Button onClick={handleAdd} variant="contained">
          <Translate value="add" />
        </Button>
      }
    >
      <Grid container alignItems="center" columnSpacing={2} rowSpacing={3}>
        <Grid item xs={12}>
          <Field
            required
            id="country-autocomplete"
            name="country"
            label={
              <Translate value="web-shop.create-order-wizard.step1.country" />
            }
            component={RemoteAutocomplete}
            url="/countries.json"
            getOptionLabel={
              /** @param {{ [x: string]: string; }} country */
              (country) => country[`name_${locale}`]
            }
          />
        </Grid>
        <Grid item xs={12}>
          <Stack rowGap={3}>
            {fields.map((_, i) => (
              <Location
                key={i}
                index={i}
                disableRemove={disableRemove}
                onRemove={handleRemove}
              />
            ))}
          </Stack>
        </Grid>
      </Grid>
    </MainCard>
  )
}

export const LocationsSection = React.memo(LocationsSectionComponent)
